import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_item_import_file_hdr_RowClass, bl_fi_item_import_file_hdr_RowInterface } from '../../../dbschema/bl_fi_item_import_file_hdr.model';

export class FinancialItemImportFileContainerModel extends BaseContainerModel {
  bl_fi_item_import_file_hdr: bl_fi_item_import_file_hdr_RowInterface = new bl_fi_item_import_file_hdr_RowClass();
}
